export default __webpack_public_path__ + "static/media/unnamed.0d87f3bc.jpg";